import React, { useContext } from 'react';
import proptypes from 'prop-types';
import {
  EventCountdownTimer as EventCountdownTimerComponent
} from '@thd-olt-component-react/event-countdown-timer';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { HomepageContext } from './context/HomepageContext';

const { string, number } = proptypes;

export function EventCountdownTimer({ id }) {
  const { isB2C } = useContext(HomepageContext);
  const data = {
    id,
    name: 'EventCountdownTimer',
    component: 'EventCountdownTimer',
    type: 'content',
    position: '',
  };

  return (
    <ErrorBoundary name="event-countdown-timer">
      <QueryProvider key={id} cacheKey={id}>
        <ImpressionProvider data={data}>
          <EventCountdownTimerComponent
            componentId={id}
            componentClass="EventCountdownTimer"
            enableB2CRadius={isB2C}
          />
        </ImpressionProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}

EventCountdownTimer.propTypes = {
  id: string
};

EventCountdownTimer.defaultProps = {
  id: undefined
};
